import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { ShieldOff, ArrowLeft } from "lucide-react";

/** Rendered when a route belongs to a module the platform owner disabled
 * for this tenant. The message never surfaces the raw module code — it
 * reads as a plain sentence in the user's language. */
export default function ModuleDisabled({ module }: { module?: string }) {
    const { t } = useTranslation();
    const label = module ? t(`module.${module}` as any, { defaultValue: module }) : "";
    return (
        <div className="max-w-2xl mx-auto py-16 text-center space-y-4" data-testid="module-disabled-page">
            <div className="inline-flex items-center justify-center w-16 h-16 rounded-full"
                style={{ background: "var(--warning-bg)", color: "var(--warning-fg)" }}>
                <ShieldOff size={28} />
            </div>
            <h1 className="text-2xl font-semibold" style={{ color: "var(--text)" }}>
                {t("access.disabled_title")}
            </h1>
            <p className="text-sm" style={{ color: "var(--text-muted)" }}>
                {label
                    ? t("access.disabled_message_named", { module: label })
                    : t("access.disabled_message")}
            </p>
            <Link to="/dashboard" data-testid="module-disabled-back"
                className="inline-flex items-center gap-2 rounded-md px-4 py-2 text-sm font-medium"
                style={{ background: "var(--primary)", color: "var(--primary-fg)" }}>
                <ArrowLeft size={14} />{t("access.disabled_back_home")}
            </Link>
        </div>
    );
}
